import { createSlice } from '@reduxjs/toolkit'

const checkoutSlice = createSlice({
    name: 'checkout',
    initialState: {
        items: [],
        error: null,
        // Per Asnake: adding an item should pop the basket panel open
        // right away, instant confirmation instead of a toast that's
        // easy to miss.
        isOpen: false,
    },
    reducers: {
        checkoutAdd(state, action) {
            //console.log('updated basket state')
            const existingTestId = state.items.filter(k => k.testId == action.payload.testId)
            if (existingTestId.length === 0 ) state.items.push(action.payload)
            state.isOpen = true
        }, 
        checkoutSetOpen(state, action) {
            state.isOpen = action.payload
        },
        checkoutRemove(state, action) {
            const removalId = action.payload
            state.items = state.items.filter(item => item.testId !== removalId) 
        
        },
        checkoutClear(state) {
            state.items = []
        },
        checkoutUpdateQty(state, action) {
            //console.log('updating item qty in basket')
            //console.log('new qty: ',action.payload)
            const testId = action.payload.id
            const newQty = action.payload.qty
            for (const item of state.items) {
                if (item.testId == testId) {
                    item.qty = newQty
                    break
                }
            }
        }
    }
});

export const { checkoutAdd, checkoutRemove, checkoutClear, checkoutUpdateQty, checkoutSetOpen } = checkoutSlice.actions;

export default checkoutSlice.reducer;